import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../state/app.state';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectsService } from '../../../../projects/core/projects.service';
import { MapService } from '../../../../../shared/services/map.service';
import { map, takeUntil } from 'rxjs/operators';
import { qpForMap } from '../../../../projects/core/projects.selectors';
import { SetQPForMap } from '../../../../projects/core/projects.actions';

@Component({
    selector: 'app-search-map-wrapper',
    templateUrl: './search-map-wrapper.component.html',
    styleUrls: ['./search-map-wrapper.component.scss'],
    standalone: false
})
export class SearchMapWrapperComponent implements OnDestroy {
  isFullScreen = false;
  existingQueryParams: any = {};
  showButtons = true;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private route: ActivatedRoute,
    private router: Router,
    private projectsService: ProjectsService,
    private mapService: MapService,
  ) {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        this.isFullScreen = 'fs' in qp;
      });

    this.mapService.showWrapperButtons
      .pipe(takeUntil(this.onDestroy))
      .subscribe(show => {
        this.showButtons = show;
      });

    this.mapService.triggerFullScreenToggle.pipe(takeUntil(this.onDestroy))
      .subscribe(show => {
        if (show) {
          this.openInFullScreen();
        } else {
          this.closeMap();
        }
      });
  }

  zoomIn() {
    this.projectsService.openRightPanel.next({});
  }

  zoomOut() {
    this.projectsService.closeRightPanel.next();
  }

  closeMap() {
    this.store.select(qpForMap)
      .pipe(
        map(result => {
          // Modify the 'date' query parameter based on your condition
          return { ...result, date: this.route.snapshot.queryParams.date, reportId: this.route.snapshot.queryParams.reportId };
        }),
      )
      .subscribe(modifiedResult => {
        this.router.navigate([], {
          queryParams: modifiedResult,
        });
      }).unsubscribe();
  }

  openInFullScreen() {
    this.store.dispatch(SetQPForMap({
      qpForMap: this.route.snapshot.queryParams,
    }));
    this.router.navigate([], {
      queryParams: {
        fs: 1,
      },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
